import type { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useLoadingStyles = makeStyles((theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main,
    },
    onPrimary: {
        color: theme.palette.onPrimary.main,
    },
}));
